export class TextSimple extends Phaser.GameObjects.Container {
  constructor(scene, x, y, text, style = null) {
    super(scene, x, y);

    this.defaultText = text;
    this.defaultStyle = style;
    this.defaultOriginX = 0;
    this.defaultOriginY = 0;

    this.loadText(this.defaultText, this.defaultStyle);
    this.renderText();
    this.redrawOrigin();
  }

  set text(t) {
    this.setText(t);
  }

  set style(s) {
    this.setStyle(s);
  }

  setStyle(style) {
    this.defaultStyle = style;
    this.loadText(this.defaultText, this.defaultStyle);
    this.renderText();
    this.redrawOrigin();
    return this;
  }

  setText(text, style = null) {
    this.defaultText = text;
    if (style !== null) {
      this.defaultStyle = style;
    }
    this.loadText(this.defaultText, this.defaultStyle);
    this.renderText();
    this.redrawOrigin();
    return this;
  }

  loadText(text, style) {
    this.texts = [];
    if (!Array.isArray(text)) {
      text = [text];
    }
    text.forEach((e) => {
      const processed = {
        text: '',
        style,
      };
      if (typeof e === 'string') {
        processed.text = e;
      } else if (e.text) {
        processed.text = e.text;
        if (e.style) {
          processed.style = Object.assign({}, style, e.style);
        }
      }
      this.texts.push(processed);
    });
  }

  clearText() {
    this.pieces?.forEach((e) => e.destroy());
    this.pieces = [];
    this.xOffset = 0;
    this.textWidth = 0;
    this.textHeight = 0;
  }

  renderText() {
    this.clearText();
    let maxSize = 0;
    this.texts.forEach((e) => {
      const txt = this.renderTextPiece(e.text, e.style);
      const bounds = txt.getBounds();

      txt.relativeX = txt.x = this.xOffset;
      txt.relativeY = txt.x = e.style?.y ?? 0;
      this.xOffset += bounds.width;
      this.textWidth = this.xOffset;
      if (e.style?.spacing) {
        this.xOffset += e.style.spacing;
      }

      this.textHeight = Math.max(this.textHeight, bounds.height);
      maxSize = Math.max(maxSize, txt.getTextMetrics().fontSize);
    });

    this.pieces.forEach((piece) => {
      if (piece.getTextMetrics().fontSize < maxSize) {
        const pieceOffset = (this.textHeight - piece.getBounds().height) / 2;
        piece.relativeY += pieceOffset;
        piece.y += pieceOffset;
      }
    });
  }

  renderTextPiece(text, style) {
    const txt = this.scene.add.text(0, 0, text, style);
    if (style?.maxWidth) {
      let size = txt.getTextMetrics().fontSize;
      while (txt.getBounds().width > style.maxWidth && size > 1) {
        size -= 1;
        txt.setFontSize(size);
      }
    }
    this.add(txt);
    this.pieces.push(txt);
    return txt;
  }

  setOrigin(x = 0, y = null) {
    if (y === null) y = x;
    this.defaultOriginX = x;
    this.defaultOriginY = y;
    this.redrawOrigin();
    return this;
  }

  redrawOrigin() {
    const offsetX = -this.textWidth * this.defaultOriginX;
    const offsetY = -this.textHeight * this.defaultOriginY;
    this.pieces.forEach((piece) => {
      piece.x = offsetX + piece.relativeX;
      piece.y = offsetY + piece.relativeY;
    });
  }

  destroy() {
    this.clearText();
    super.destroy();
  }
}
